module.exports = __webpack_public_path__ + "img/mt4logo3.dfe96624.svg";